export const payHub = process.env.REACT_APP_PAYHUB_URL
// export const payHub = "https://localhost:7042/PayHub"